import React, { useRef, useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
// import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const ADD_STHAN_TO_USER = "add-sthan-to-user";
const REMOVE_STHAN_TO_USER = "remove-sthan-from-user";

const AdminAddSthanToUser = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
  };
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const userRef = useRef();
  const errRef = useRef();

  const { auth } = useAuth();

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const personId = queryParams.get('person_id');
  const name = queryParams.get('name');
  const mobile = queryParams.get('mobile');
  const [error, setError] = useState(null);

  const [khandList, setKhandList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");

  const [mandalamList, setMandalamList] = useState([]);
  const [selectedMandalamId, setSelectedMandalamId] = useState("");

  const [sthanList, setSthanList] = useState([]);
  const [selectedSthanId, setSelectedSthanId] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const SthansOfSthanUserPerPage = 15;
  const [SthansOfSthanUser, setSthansOfSthanUser] = useState([]);



  const fetchKhands = useCallback(async () => {
    if (!auth.level_id) return;

    // setLoading(true);
    // setSthans([]);
    try {
      const res = await axiosPrivate.get(`list-khands-in-arthik-sakha?arthik_sakha_id=${auth.level_id}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setKhandList(data);
      if (data.length > 0) {
        setSelectedKhandId(data[0].khand_id); // optional default
      } else {
        setSelectedKhandId("");
      }
    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    }
    // finally {
    //   setLoading(false);
    // }
  }, [axiosPrivate, auth.level_id]);

  useEffect(() => {
    if (auth.level_id) {
      fetchKhands();
    }
  }, [auth.level_id]);


  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");
        // setSthans([]); // clear table
        return;
      }

      // setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        if (data.length > 0) {
          const firstMandalamId = data[0].mandal_id;
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstMandalamId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          // setSthans([]); // clear table
        }

      } catch (err) {
        console.error("mandals fetch failed:", err);
        setError("Failed to load mandals list");
        setMandalamList([]);
        setSelectedMandalamId("");
        // setSthans([]);
      }
      // finally {
      //   setLoading(false);
      // }
    };

    fetchMandalamList();
  }, [selectedKhandId]);


  useEffect(() => {
    const fetchSthanList = async () => {
      if (!selectedKhandId) {
        setSthanList([]);
        setSelectedSthanId("");
        // setSthans([]); // clear table
        return;
      }

      // setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-sthans?mandal_id=${selectedMandalamId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setSthanList(data);
        if (data.length > 0) {
          const firstSthanId = data[0].mandal_id;
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstSthanId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          // setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setSthanList([]);
        setSelectedSthanId("");
        // setSthans([]);
      }
      // finally {
      //   setLoading(false);
      // }
    };

    fetchSthanList();
  }, [selectedMandalamId]);


  const fetchSthansOfSthanUser = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-sthans-of-sthan-user?person_id=${personId}`, {
        withCredentials: true,
      });
      const franchiseList = response.data;
      setSthansOfSthanUser(franchiseList);

      // setLoading(false);
    } catch (error) {
      console.error("Error fetching sthans of sthan user:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No sthans of sthan user available.");
      // setLoading(false);
    }
  }, [axiosPrivate, personId]); // 👈 dependency added

  useEffect(() => {
    fetchSthansOfSthanUser();
  }, [personId]);

  const AddSthanToUserSubmit = async (e) => {
    e.preventDefault();

    try {
      var data = JSON.stringify({
        sthan_id: selectedSthanId,
        person_id: personId,

      });

      const response = await axiosPrivate.post(ADD_STHAN_TO_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);


      fetchSthansOfSthanUser();
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
    }

  };


  const RemoveSthanFromUser = async (e, sthanId, personId) => {
    e.preventDefault();
    try {
      const data = JSON.stringify({
        sthan_id: sthanId,
        person_id: personId
      });

      console.log("data = ", data)

      const response = await axiosPrivate.post(REMOVE_STHAN_TO_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      fetchSthansOfSthanUser();
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message?.msg || "Unknown error";
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Operation Failed");
      }
    }
  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };



  const indexOfLastSthansOfSthanUser = currentPage * SthansOfSthanUserPerPage;
  const indexOfFirstSthansOfSthanUser = indexOfLastSthansOfSthanUser - SthansOfSthanUserPerPage;
  const currentSthansOfSthanUser = SthansOfSthanUser.slice(indexOfFirstSthansOfSthanUser, indexOfLastSthansOfSthanUser);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(SthansOfSthanUser.length / SthansOfSthanUserPerPage);

  return (
    <>
      <Container>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}
        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>


        <section className="userregbody2">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={errRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>


          <div className="wrapper wrapper2 new_arthiksakha">
            <form>
              <h3 class="arthik_head">Add new sthan to <span class="colorChange">{name}</span></h3>

              <p className="arthik_head">Phone: {mobile}</p>
              <form onSubmit={AddSthanToUserSubmit}>

                <Row>
                  <Col md={6}>

                    <Form.Label className="newformstyle">Khand</Form.Label>
                    <Form.Select
                      className="newselectstyle"
                      value={selectedKhandId}
                      onChange={(e) => setSelectedKhandId(e.target.value)}
                      disabled={!khandList.length}
                    >
                      <option value="">-- Select Khand --</option>
                      {khandList.map((k) => (
                        <option key={k.khand_id} value={k.khand_id}>
                          {k.khand_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>

                  <Col md={6}>

                    <Form.Label className="newformstyle">Mandalam</Form.Label>
                    <Form.Select
                      className="newselectstyle"
                      value={selectedMandalamId}
                      onChange={(e) => {
                        const mandalamId = e.target.value;
                        setSelectedMandalamId(mandalamId); // Correctly set Mandalam ID
                      }}
                      disabled={!mandalamList.length}
                    >

                      <option value="">-- Select Mandalam --</option>
                      {mandalamList.map((m) => (
                        <option key={m.mandal_id} value={m.mandal_id}>
                          {m.mandal_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>


                <Form.Label className="newformstyle">Sthan</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedSthanId}
                  onChange={(e) => {
                    const sthanId = e.target.value;
                    setSelectedSthanId(sthanId); // Correctly set Mandalam ID
                  }}
                  disabled={!sthanList.length}
                >

                  <option value="">-- Select Sthan --</option>
                  {sthanList.map((m) => (
                    <option key={m.sthan_id} value={m.sthan_id}>
                      {m.sthan_name}
                    </option>
                  ))}
                </Form.Select>
              </form>



              <button
                type="button" // Important to prevent form submit
                className="btn"
                onClick={AddSthanToUserSubmit} // Call this for "Sign Up"
                disabled={!selectedSthanId}
              >
                Submit
              </button>
            </form>

          </div>

          <br></br>
          <div className="wrapperemp2">
            {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
            <h3>List Sthans of {name}</h3>

            <div className="table-container">
              <table id="customers">
                <thead>
                  <tr>
                    <th>Sthan name (Malayalam)</th>
                    <th>Sthan name</th>
                    <th>Options</th>
                  </tr>
                </thead>

                <tbody>
                  {error ? (
                    <tr>
                      <td colSpan="6" className="text-danger text-center">
                        {error}
                      </td>
                    </tr>
                  ) : SthansOfSthanUser.length === 0 ? (
                    <tr>
                      <td colSpan="6">No Data available.</td>
                    </tr>
                  ) : (
                    currentSthansOfSthanUser.map(SthanOfSthanUser => (
                      <tr key={SthanOfSthanUser.sthan_id}>
                        <td>{SthanOfSthanUser.sthan_name}</td>
                        <td>{SthanOfSthanUser.search_tag}</td>


                        <td>
                          <button class="btn btn-danger" onClick={(e) => RemoveSthanFromUser(e, SthanOfSthanUser.sthan_id, SthanOfSthanUser.person_id)}>
                            Remove Sthan
                          </button>

                        </td>
                      </tr>
                    ))
                  )}
                </tbody>


              </table>
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </section>
        {/* )} */}
      </Container>
    </>
  );
};

export default AdminAddSthanToUser;
